import React from "react";
import { useDispatch } from "react-redux";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { getUser } from "../../../../../store/slices/auth-slice";
import { useAppSelector } from "../../../../../hooks/app";
import { ROLES } from "../../../../../constants";

function SoloFlightFour({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [airspace, setAirspace] = React.useState("");
  const [limitations, setLimitations] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I certified that ${name} has received the required training of §61.95(a). I have determined [he or she] is proficient to conduct solo flights in ${airspace} airspace. Limitations §61.89(a)(8): ${limitations}`;
    dispatch(setTemplateText(templateText));
  }, [name, airspace, limitations, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 61.101(c)</label>
      </div>

      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received the required training of §61.95(a). I have determined [he or she] is proficient to conduct solo flights in
          <input
            type="text"
            onChange={(e) => setAirspace(e.target.value)}
            placeholder="airspace"
            style={{ margin: '0 5px' }}
          /> airspace. Limitations §61.89(a)(8):
          <input
            type="text"
            onChange={(e) => setLimitations(e.target.value)}
            className="input_long"
            style={{ margin: '0 5px' }}
          />
        </p>
      </div>
    </TemplateLayout>
  );
}

export default SoloFlightFour;
